//TRIGGER FUNCTIONS ON WINDOW LOAD

var onLoad = function(event){

    $('.mob-menu .menu-close').on('click', function () {
        $('body').removeClass('fixed menu-active');
    });

    var pp = $('.payment-pending');

    if (pp.length > 0) {
        setTimeout(function () {
            checkStatus(pp.data('id'));
        }, 5000)
    }

    function checkStatus(id) {
        var data = {
            'action' : 'check_cart_status',
            'id' : id
        };
        $.get(postre.ajax_url, data, function(response){
            if (response.data.status === 19) {
                setTimeout(function () {
                    checkStatus(id);
                }, 5000)
            } else if (response.data.status === 20) {
                $('.payment-pending').addClass('hidden');
                $('.payment-approved').removeClass('hidden');

                triggerTransaction();

            } else if (response.data.status === 21) {
                $('.payment-pending').addClass('hidden');
                $('.payment-canceled').removeClass('hidden');
            }
        });
    }

    var bw = $('.banner-wrap-vt');
    var bwpt = $('.banner-wrap-pt');
    var bwmain = $('.banner-wrap-main');

    if (!sessionStorage.refbanner) {

        if(bw.length > 0) {

            var initBanner = function () {
                setTimeout(function () {

                    bw.addClass('active');
                    $('body').addClass('banner-active');
                    sessionStorage.setItem('refbanner', true);

                }, 1000 + 1000 * bw.data('timeout'));
            }

            if(bw.data('start') && bw.data('end')){

                var start = new Date(bw.data('start')),
                    end = new Date(bw.data('end')),
                    now = new Date();

                if(start.getTime() < now.getTime() && now.getTime() < end.getTime()){

                    //console.log('Will start Banner');

                    initBanner();

                }

            }else {
                initBanner();
            }

        }

    }

    if (!sessionStorage.refbannerpt) {

        if(bwpt.length > 0) {

            var initBanner = function () {
                setTimeout(function () {

                    bwpt.addClass('active');
                    $('body').addClass('banner-active');
                    sessionStorage.setItem('refbannerpt', true);

                }, 1000 + 1000 * bwpt.data('timeout'));
            }

            if(bwpt.data('start') && bwpt.data('end')){

                var start = new Date(bwpt.data('start')),
                    end = new Date(bwpt.data('end')),
                    now = new Date();

                if(start.getTime() < now.getTime() && now.getTime() < end.getTime()){

                    //console.log('Will start Banner');

                    initBanner();

                }

            }else {
                initBanner();
            }

        }

    }

    if(bwmain.length > 0) {

        var initBanner = function () {
            setTimeout(function () {

                bwmain.addClass('active');
                $('body').addClass('banner-active');

            }, 1000 + 1000 * bwmain.data('timeout'));
        };

        initBanner();

    }

    // var menuButtons = $('.topbar .buttons .menu-item');
    //
    // if(menuButtons.length > 0) {
    //     menuButtons.addClass('load');
    //
    //     setTimeout(function () {
    //         menuButtons.removeClass('load').addClass('animation-ended');
    //     }, 800);
    // }

    if(trainingGrid.length > 0) {
        trainingGrid.isotope({
            layoutMode: 'fitRows',
            fitRows: {
                gutter: 20
            },
            filter: '*:not(.special)'
        });

        // trainingGrid.find('.card .bg-skew').tilt({
        //     'perspective': 2000,
        //     'speed': 500
        // });

        trainingSelect.find('select').select2({
            width: '100%',
            minimumResultsForSearch: -1
        })
    }

    if(coachesGrid.length > 0) {
        // coachesGrid.isotope({
        //     layoutMode: 'fitRows',
        //     fitRows: {
        //         gutter: 20
        //     },
        //     filter: '*:not(.special)'
        // });

        // trainingGrid.find('.card .bg-skew').tilt({
        //     'perspective': 2000,
        //     'speed': 500
        // });

        coachesSelect.find('select').select2({
            width: '100%',
            minimumResultsForSearch: -1
        })
    }

    var singleTrainingCards = $('.single-description .training-cards .card .bg-skew');

    // if(singleTrainingCards.length > 0) {
    //     singleTrainingCards.tilt({
    //         'perspective': 2000,
    //         'speed': 500
    //     })
    // }

    var singleCoachCards = $('.single-description .trainers-cards .card .bg-skew');

    // if(singleCoachCards.length > 0) {
    //     singleCoachCards.tilt({
    //         'perspective': 2000,
    //         'speed': 500
    //     })
    // }

    var coachCards = $('.coaches .coaches-cards .card .bg-skew');

    // if(coachCards.length > 0) {
    //     coachCards.tilt({
    //         'perspective': 2000,
    //         'speed': 500
    //     })
    // }

    var newsCards = $('.news .news-grid .news-block .bg-skew');

    // if(newsCards.length > 0) {
    //     newsCards.tilt({
    //         'perspective': 2000,
    //         'speed': 500
    //     })
    // }

    var newsGallery = $('.news-gallery .gallery-carousel');

    if(newsGallery.length > 0) {

        var rangeStart = 1,
            rangeEnd = 1;

        newsGallery.on('init', function (event, slick) {
            rangeEnd = newsGallery.find('.slick-current .img-block').length;
        });
        
        newsGallery.on('beforeChange', function (event, slick, currentSlide, nextSlide) {

            var slickCurrent = newsGallery.find('.slick-current'),
                forwards = true,
                countImg;

            if(nextSlide < currentSlide) {
                forwards = false;
            }

            //GOING FORWARDS
            if(forwards && slickCurrent.next().length > 0){
                countImg = slickCurrent.next().find('.img-block').length;

                rangeStart = rangeEnd + 1;
                rangeEnd += countImg;
            }

            //GOING BACK
            if(!forwards && slickCurrent.prev().length > 0){
                countImg = slickCurrent.prev().find('.img-block').length;

                rangeEnd = rangeStart - 1;
                rangeStart -= countImg;
            }

            newsGallery.siblings('.counter').find('.current').text(rangeStart +' - '+ rangeEnd);

        });
        
        newsGallery.slick({
            'accessibility': false,
            'infinite': false,
            'rows': 2,
            'slidesPerRow': 3,
            'prevArrow': '<div class="slick-prev"></div>',
            'nextArrow': '<div class="slick-next"></div>',
            'responsive': [
                {
                    breakpoint: 991,
                    settings: {
                        'slidesPerRow': 2,
                        'rows': 3,
                    }
                }
            ]
        });
    }

    $('.news-gallery [data-fancybox="gallery"]').fancybox({
        toolbar: false,
        autoSize: false,
        src: $(this).data('src'),
        thumbs: {
            hideOnClose: false
        },
        smallBtn: false,
        baseClass: "fancybox-news-gallery",
        btnTpl: {
            // Arrows
            arrowLeft:
                '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"></button>',

            arrowRight:
                '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"></button>',
        },
        baseTpl:
            '<div class="fancybox-container" role="dialog" tabindex="-1">' +
            '<div class="fancybox-bg"></div>' +
            '<div class="fancybox-inner">' +
            '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
            '<div class="fancybox-toolbar">{{buttons}}</div>' +
            '<div class="fancybox-navigation">{{arrows}}</div>' +
            '<div class="fancybox-stage"><div class="fancybox-close-elem" data-fancybox-close><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg></div></div>' +
            '<div class="fancybox-caption"></div>' +
            "</div>" +
            "</div>",
    });

    $('.fancybox-container .fancybox-close-small').on('click', function (e) {
       e.preventDefault();

        $.fancybox.close();
    });

    $('.club-changer .trigger').on('click', function (e) {
       e.preventDefault();

       $(this).parent().toggleClass('active');
    });

    var schedulesSelectors = $('.schedules .selector');

    if(schedulesSelectors.length > 0) {

        var instance;

        var skipScroll = ['reserved'];

        schedulesSelectors.find('select').on('select2:open', function (e) {
            //console.log('It\'s opening');
            var select = $(e.target);
            var name = select.attr('name');

            if(skipScroll.indexOf(name) === -1) {

                setTimeout(function () {

                    instance = $('.select2-results__options').overlayScrollbars({
                        sizeAutoCapable: false
                    }).overlayScrollbars();

                }, 100)

            }else {

                $('.select2-results__options').addClass('auto-height');

            }
        });

        schedulesSelectors.find('select').on('select2:closing', function (e) {
            //console.log('It\'s closing');

            var select = $(e.target);
            var name = select.attr('name');

            if(skipScroll.indexOf(name) === -1) {

                instance.destroy();

            }else {

                $('.select2-results__options').removeClass('auto-height');

            }
        });

        schedulesSelectors.find('select').select2({
            width: '100%',
            minimumResultsForSearch: -1
        });

        schedulesSelectors.find('select[name="time"]').on('change', function (e) {
            // console.log($(this).val());

            var val = $(this).val();

            if(val !== 'all') {

                var weeksCarousel = $('.schedules .weeks-carousel'),
                    col = weeksCarousel.find('.col[data-date="'+ val +'"]').eq(0);

                // console.log(col);

                if(col.length > 0) {
                    var index = col.closest('.slick-slide').data('slick-index');

                    var currentSlide = weeksCarousel[0].slick.currentSlide;

                    if( currentSlide !== index ) {

                        weeksCarousel.slick('slickGoTo', index);

                    }
                }
            }
        });
    }

    var invoicesSelectors = $('.my-invoices .selector');

    if(invoicesSelectors.length > 0) {

        invoicesSelectors.find('select').select2({
            width: '100%',
            minimumResultsForSearch: -1
        });
    }

    //SELF-SERVICE FUNCTIONS

    var purchaseBlockCarousel = $('.package-purchase-form .purchase-carousel');

    if(purchaseBlockCarousel.length > 0){

        purchaseBlockCarousel.on('beforeChange', function (event, slick, currentSlide, nextSlide) {

            var block = purchaseBlockCarousel.siblings('.block-switcher').find('.block[data-block=payment]');

            if(nextSlide === 0){

                block.removeClass('active');

            }else if(nextSlide === 1){

                block.addClass('active');

            }

        });

        purchaseBlockCarousel.on('afterChange', function () {

            $('html, body').animate({'scrollTop': 0}, 500);

        });

        purchaseBlockCarousel.slick({
            'accessibility': false,
            'draggable': false,
            'infinite': false,
            'swipe': false,
            'touchMove': false,
            'arrows': false,
            'adaptiveHeight': true
        })
    }

    var packagePurchaseForm = $('.package-purchase-form form');

    if(packagePurchaseForm.length > 0) {

        packagePurchaseForm.find('select').select2({
            width: '100%',
            minimumResultsForSearch: -1
        });

        var datepickerTemplate = '';

        datepickerTemplate += '<div></div><div class="datepicker-container">';
        datepickerTemplate += '<div class="datepicker-panel" data-view="days picker">';
        datepickerTemplate += '<ul data-view="months-selector">';
        datepickerTemplate += '<li data-view="month prev"></li>';
        datepickerTemplate += '<li data-view="month current"></li>';
        datepickerTemplate += '<li data-view="month next"></li>';
        datepickerTemplate += '</ul>';
        datepickerTemplate += '<ul data-view="week"></ul>';
        datepickerTemplate += '<ul data-view="days"></ul>';
        datepickerTemplate += '</div>';
        datepickerTemplate += '<div class="custom-selector"><div class="button" onclick="purchageDatepickerDate();">Šiandien</div></div>';
        datepickerTemplate += '</div>';

        // packagePurchaseForm.find('input[name="member_activation_date"]').on('show.datepicker', function () {
        //
        //     console.log('show datepicker');
        //
        // });

        packagePurchaseForm.find('input[name="member_activation_date"]').on('pick.datepicker', function () {

            packagePurchaseForm.find('input[name="member_activation_date"]').datepicker('hide');

        });

        packagePurchaseForm.find('input[name="member_activation_date"]').datepicker({
            startDate: datepicker.start,
            endDate: datepicker.end,
            language: 'lt-LT',
            autoHide: false,
            template: datepickerTemplate
        });

        packagePurchaseForm.find('.package-list').overlayScrollbars({
            // sizeAutoCapable: false,
        }).overlayScrollbars();
    }

    $('.no-time-block .button-close svg').on('click', function () {
        $('.no-time-block').hide()
    });

    $('.page-template-template--homepage .cards-wrap .card').on('mouseenter', function () {
        $('.sub-logo').css('opacity', 0);
        var which = $(this).data('hover');
        $('.sub-logo.' + which).css('opacity', 1);
    }).on('mouseleave', function () {
        $('.sub-logo').css('opacity', 0);
    });

    var bigSlider = $('.big-slider .big-slider-slides'),
        bigSliderArgs = {
            'accessibility': false,
            'arrows': false,
            'draggable': false,
            'swipe': false,
            'touchMove': false,
            'autoplay': true
        };

    bigSlider.not('.slick-initialized').slick(bigSliderArgs);

    $('.big-slider-next').on('click', function () {
        bigSlider.slick('slickNext');
    });
    $('.big-slider-prev').on('click', function () {
        bigSlider.slick('slickPrev');
    });
    $('.slide-number').on('click', function () {
        var to = $(this).data('to');
        bigSlider.slick('slickGoTo', to-1);
    });

    onResize();
};

$(window).on('load', onLoad);